import { useTranslation } from 'react-i18next'

import Landscape500SVG from '../../assets/images/500.svg?react'
import * as S from '../ServerError/styles'

const MaintenancePage = () => {
	const { t } = useTranslation()

	return (
		<S.Page
			alignItems="center"
			justifyContent="center"
			display="flex"
			flexDirection="column"
		>
			<Landscape500SVG />
			<S.Title>{t('maintenance.title')}</S.Title>
			<S.Subtitle>{t('maintenance.subtitle')}</S.Subtitle>
		</S.Page>
	)
}

export { MaintenancePage }
